'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import { useEffect, useRef, useState } from 'react';

import { usePathname } from 'next/navigation';

const ScrollReset = () => {
    const pathname = usePathname();
    const [hasVisited, setHasVisited] = useState(false);

    // TEMP FIX FOR NEXT.JS SCROLL RESTORATION BUG and Sharpness Overlays
    // until the next.js bug is fixed, this makes general UX for sharpness stories nice again
    // does not force scroll to top when route changes to a sharpness story and back

    const lastPathsRef = useRef([]);
    const cameFromSharpnessStory = useRef(false);

    useEffect(() => {
        lastPathsRef.current = [pathname, ...lastPathsRef.current.slice(0, 1)];

        const isSharpnessStory = pathname.includes('sharpness');
        const previousPath = lastPathsRef.current[1];

        if (isSharpnessStory) {
            cameFromSharpnessStory.current = false;
        } else if (previousPath && previousPath.includes('sharpness')) {
            cameFromSharpnessStory.current = true;
        } else {
            cameFromSharpnessStory.current = false;
        }

        if (
            hasVisited &&
            !isSharpnessStory &&
            !cameFromSharpnessStory.current
        ) {
            window.scroll(0, 0);
        } else {
            setHasVisited(true);
        }
    }, [pathname, hasVisited]);

    return null;
};

export default ScrollReset;
